import ActionTypes from "../../../constants";

const initialState = {
  rejectedBPlist: null,
  pageInfo: {
    currentPage: 1,
    pageSize: 15,
    totalRecords: 0,
  }
};
const rejectedBusinessPartners = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_REJECTED_BUSINESS_PARTNERS_SUCCEEDED: {
      const { rejectedBPlist, pageInfo } = action;

      return {
        ...state,
        rejectedBPlist,
        pageInfo
      };
    }
    default: {
      return state;
    }
  }
};

export default rejectedBusinessPartners;
